/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12.036 1.473a.95.95 0 0 1 .79-.423h.385a.95.95 0 0 1 .946 1.039l-.614 6.517h4.82a.95.95 0 0 1 .798 1.466l-8.055 12.444a.95.95 0 0 1-1.689-.187l-.346-.937a.95.95 0 0 1-.054-.423l.722-7.225H5.636a.95.95 0 0 1-.79-1.476l7.19-10.795Zm-.06 3.519L7.41 11.844h3.378a.95.95 0 0 1 .945 1.045l-.61 6.103 5.493-8.486H12.5a.95.95 0 0 1-.946-1.039l.421-4.475Z"
})), "0 0 24 24", "Flash");